import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const numClampUiNodeSpec: NodeSpec<NodeCfg<'numClamp'>> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { max: 0, min: 0 }, id: getUID(), kind: 'numClamp', disabled: false }),
    controls: nodeCfg => ({
        max: defineControlOpts({ cfg: { kind: 'number', label: 'Max' }, on: { 'update:value': defaultControlUpdateValueHandler }, value: nodeCfg.controlValues.max }),
        min: defineControlOpts({ cfg: { kind: 'number', label: 'Min' }, on: { 'update:value': defaultControlUpdateValueHandler }, value: nodeCfg.controlValues.min }),
    }),
    inputs: () => ({ input: { socket: 'number', label: 'Input' } }),
    kindLabel: 'Number Clamp',
    nodeCategory: 'number',
    outputs: () => ({ output: { socket: 'number', label: 'Output' } }),
    validator: node => {
        const errors: Record<string, string> = {};
        if (typeof node.controlValues.min === 'number' && typeof node.controlValues.max === 'number' && node.controlValues.min > node.controlValues.max) {
            errors.min = 'Min must be less than or equal to Max';
            errors.max = 'Max must be greater than or equal to Min';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
